const CACHE_PREFIX = "syt-hotel-ticket-cache-";
const PENDING_PREFIX = "syt-hotel-pending-flow-";
const CACHE_TTL_MS = 30 * 60 * 1000;

const safeParse = (raw) => {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const cacheHotelTicket = (ref, data) => {
  const key = String(ref ?? "").trim();
  if (!key || !data || typeof data !== "object") {
    return;
  }
  try {
    sessionStorage.setItem(
      `${CACHE_PREFIX}${key}`,
      JSON.stringify({ savedAt: Date.now(), data }),
    );
  } catch {
    /* ignore quota / private mode */
  }
};

export const getCachedHotelTicket = (ref) => {
  const key = String(ref ?? "").trim();
  if (!key) {
    return null;
  }
  try {
    const parsed = safeParse(
      sessionStorage.getItem(`${CACHE_PREFIX}${key}`),
    );
    if (!parsed?.data || typeof parsed.data !== "object") {
      return null;
    }
    if (Date.now() - Number(parsed.savedAt ?? 0) > CACHE_TTL_MS) {
      sessionStorage.removeItem(`${CACHE_PREFIX}${key}`);
      return null;
    }
    return parsed.data;
  } catch {
    return null;
  }
};

export const setHotelPendingFlow = (ref, flow) => {
  const key = String(ref ?? "").trim();
  if (!key || !flow) {
    return;
  }
  try {
    sessionStorage.setItem(`${PENDING_PREFIX}${key}`, String(flow));
  } catch {
    /* ignore */
  }
};

export const getHotelPendingFlow = (ref) => {
  const key = String(ref ?? "").trim();
  if (!key) {
    return null;
  }
  try {
    return sessionStorage.getItem(`${PENDING_PREFIX}${key}`);
  } catch {
    return null;
  }
};

export const clearHotelPendingFlow = (ref) => {
  const key = String(ref ?? "").trim();
  if (!key) {
    return;
  }
  try {
    sessionStorage.removeItem(`${PENDING_PREFIX}${key}`);
  } catch {
    /* ignore */
  }
};

export const prefetchHotelTicket = (ref) => {
  const key = String(ref ?? "").trim();
  if (!key || getCachedHotelTicket(key)) {
    return Promise.resolve(getCachedHotelTicket(key));
  }
  return import("../../helpers/ApiClient")
    .then(({ default: ApiClient }) =>
      ApiClient.get(`hotels-v2/hotelDetails/${key}`),
    )
    .then((res) => {
      const data = res?.data ?? res;
      if (data && typeof data === "object" && Object.keys(data).length > 0) {
        cacheHotelTicket(key, data);
        return data;
      }
      return null;
    })
    .catch(() => null);
};
